import { useEffect, useState } from "react";
import { SortedResultsList, useQuestionizerStore } from "../types/state.ts";
import {
  FDWAntragsteller,
  FDWResultEntry,
} from "../../../restfd2/fdw_result.ts";
import Checkbox from "./checkbox.tsx";
import { select } from "https://esm.sh/cheerio-select@2.1.0/lib/index.d.ts";

export function QuestionizerResultItem(props: { entry: FDWResultEntry }) {
  const include_in_print = useQuestionizerStore(
    (state) => state.include_in_print
  );
  const setIncludeInPrint = useQuestionizerStore(
    (state) => state.setIncludeInPrint
  );
  const request_preview_text_block = useQuestionizerStore(
    (state) => state.request_preview_text_block
  );

  const activeFpId = useQuestionizerStore(
    (state) => state.activeFpId
  );

   const setActiveFpId = useQuestionizerStore(
    (state) => state.setActiveFpId
  );

  //const setIncludeInPrintExclusive = useQuestionizerStore((state) => state.setIncludeInPrintExclusive);

  const select_element = ()=>{
        setActiveFpId(props.entry.fp_id);
        request_preview_text_block(props.entry.fp_id);
        //console.log("props.entry.fp_id", props.entry.fp_id);
      };

  return (
    <div className={"result-item flex flex-row items-start mb-4 cursor-pointer " + (activeFpId == props.entry.fp_id ? "result-item--active text-white bg-[#004696]" : "")}>
      <Checkbox
        value={include_in_print[props.entry.fp_id]}
        onChange={(value) => {
          setIncludeInPrint(props.entry.fp_id, value);
        }}
      />
      <div className="mr-4 flex flex-col items-start" 
       tabIndex={0}
        onKeyUp={(event)=>{
          if ((event.code != " ")  && (event.code != "Enter")) { return } 
          select_element();
        }}
      onClick={()=>select_element()}>
        <span className="result-item__name font-bold">
          {props.entry.fp_name}
        </span>
        <span className="result-item__betrag">{props.entry.fp_betrag}</span>
      </div>
    </div>
  );
}